<template>
  <a-tooltip>
    <template #title>{{ props.value || "-" }}</template>
    <div class="flex justify-center items-center w-full py-3">
      <div
        class="profile_circle cursor-pointer w-7"
        :class="getProfileColor(userInitials)"
      >
        <span class="text-sm font-normal opacity-60">
          {{ userInitials.toUpperCase() }}
        </span>
      </div>
    </div>
  </a-tooltip>
</template>
<script setup>
import { defineProps, computed } from "vue";
import { getProfileColor, getUsernameInitials } from "@/src/utils/utils.js";

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  row: {
    type: Object,
    default: () => ({}),
  },
});

const userInitials = computed(() => 
  getUsernameInitials(props.value || "")
);
</script>

